export const erpDriverTypes = [
    {
        items: [
            {
                id:   1,
                name: 'Signature'
            }
        ],
        name:      'FSM Driver Types',
        itemProps: {
            type: 'erpDriverType'
        }
    }
];
